import { isSupported as sdkIsSuported } from '@loomhq/loom-sdk';

export const isSupported = sdkIsSuported;
